module.exports = __webpack_public_path__ + "img/mobile-legends.a03c48f.jpg";